module.exports = __webpack_public_path__ + "img/12_54.b0aa3885.png";